export default "__VITE_ASSET__Cm96nej7__"